import { global_hooks } from 'src/globals';

global_hooks.on('init', init);
function init() {
	if (document.querySelector('.search_popup')) {
		import('./search_popup');
	}
}
